export default __webpack_public_path__ + "static/LobbyView_CapitolBuilding-e9c566d0b6cfc6c40b6a6df34aec8962.png";